<h1 mat-dialog-title>
  <span *ngIf="!editMode">Add New</span>
  <span *ngIf="editMode">Update</span>
  </h1>
<div class="field-full" [formGroup]="dataForm">

  <mat-form-field>
    <mat-label>Name</mat-label>
    <input type="text" matInput formControlName="name">
  </mat-form-field>

  <mat-form-field *ngIf="data.type == 'courier'">
    <mat-label>Url</mat-label>
    <input type="text" matInput formControlName="url">
  </mat-form-field>

  <mat-form-field *ngIf="data.type == 'warehouse'">
    <mat-label>Sort Order</mat-label>
    <input type="text" matInput formControlName="sort_order">
  </mat-form-field>

  <mat-form-field>
    <mat-label>Status</mat-label>
    <mat-select formControlName="status">
      <mat-option [value]="1">Enable</mat-option>
      <mat-option [value]="0">Disable</mat-option>
    </mat-select>
  </mat-form-field>

</div>



<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="warn" (click)="submitForm()" [disabled]="!dataForm.valid" *ngIf="!submitted">
    <span *ngIf="!editMode">Submit</span>
    <span *ngIf="editMode">Update</span>
  </button>
</mat-dialog-actions>
